<div class="busy-overlay-parent">
  <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <ng-container *ngrxLet="logRows$ as logRows">
    <ng-container *ngIf="logRows">
    <div *ngIf="!isLoading  && logRows.length==0" class="text-muted italic text-center">
      ---
    </div>
    <table *ngIf="logRows.length" class="comment-table table table-borderless m-0">
      <tr *ngFor="let logRow of logRows; index as index;" style="border:0;" [ngClass]="logRow.rowClass">
          <ng-container *ngIf="!logRow.archived">
              <td class="p-1 text-left">
                  <div class="comment-date">{{logRow.timestamp|date:'yyyy-MM-dd HH:mm:ss'}}</div>
                  <div>{{logRow.text}}</div>
              </td>
          </ng-container>
      </tr>
    </table>
    </ng-container>
  </ng-container>
</div>


